import settings from './settings';

/**
 * Class representing Anime GIF source.
 */
class Anime {
  /**
   * Create an Anime GIF source.
   * @param {string} id - Video Media ID.
   */
  constructor(id) {
    this.id = id;
    this.baseUrl = settings.animeBaseUrl;
    this.timeout = settings.timeout;
    this.HEADStatus = 404;
  }

  /**
   * Check if Anime GIF URL is valid.
   */
  check() {
    return new Promise(resolve => {
      fetch(this.url, {
        method: 'HEAD',
      })
        .then(response => {
          this.HEADStatus = response.status;
          return resolve(this.hasAnime);
        })
        .catch(() => resolve(false));
    });
  }

  /**
   * Return Anime GIF/WebP check status.
   * @return {boolean}
   */
  get hasAnime() {
    return this.HEADStatus === 200;
  }

  /**
   * Return GIF URL.
   */
  get url() {
    const extension = settings.canUseWebP ? 'webp' : 'gif';
    return `${this.baseUrl}/${this.id}.${extension}`;
  }
}

export default Anime;
